﻿import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";
import { hasPermission, validRoles } from "@/services/Utils";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const SpeciesTableBody = ({ handleDelete, permissions }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { species } = useSelector((state) => state.maintainers_species);
	const { customer } = useSelector((state) => state.auth.user);

	return (
		<tbody>
			{species &&
				species.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}`}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text}`} style={{ justifyContent: "center" }}>
									{item.category_name}
								</div>
							</td>
							{!!customer.use_estates_parents && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.long_text}`} style={{ justifyContent: "center" }}>
										{item.estates_parents}
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text}`} style={{ justifyContent: "center" }}>
									{item.estates}
								</div>
							</td>
							{isAdmin && !location.pathname.includes("configuracion") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
										{item.customer_name}
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/paso-1/editar/" + item.slug)} />
									)}
									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default SpeciesTableBody;
